import { STORYBLOK_WEBSITE_ROOT } from '../constants';

export const resolvePathFromSlug = (slug: string) => {
  if (slug.startsWith(STORYBLOK_WEBSITE_ROOT))
    return slug.slice(STORYBLOK_WEBSITE_ROOT.length);
  return null;
};
